"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var cache_1 = require("./cache");
var HttpRequest_1 = require("./HttpRequest");
var TokenDecoder_1 = require("./TokenDecoder");
var version_1 = require("./version");
var LocalStorage_1 = require("./LocalStorage");
var Errors_1 = require("./Errors");
/**
 * The Authentication Client
 */
var AuthClient = /** @class */ (function () {
    /**
     *
     * @param {AuthClientOptions} options
     */
    function AuthClient(options) {
        var _this = this;
        this.options = options;
        this.scopes = [];
        this.DEFAULT_SCOPE = []; // empty for now
        /**
         *
         * @param {string} authString
         * @deprecated This is a workaround for the currently missing magic link support
         */
        this.addJWTAuthorization = function (authString) {
            _this.httpRequest.addHeader("Authorization", "Bearer " + authString);
            var decoder = new TokenDecoder_1.TokenDecoder(authString);
            var decodedToken = decoder.getDecodedToken("*.uninow.com");
            LocalStorage_1.default.setItem("auth.is.authenticated", { value: true });
            LocalStorage_1.default.setItem("auth.token", {
                raw: authString,
                expiresAt: decodedToken.expiredAt()
            });
        };
        this.cache = new cache_1.default();
        this.domainUrl = "" + this.options.domain;
        this.application = this.options.application;
        this.httpRequest = new HttpRequest_1.HttpRequest({ baseUrl: this.domainUrl });
        // add the default scopes
        this.DEFAULT_SCOPE.forEach(function (s) { return _this.scopes.push(s); });
        if (typeof options.scopes !== "undefined") {
            options.scopes.forEach(function (s) {
                // prevent for duplicates
                if (!_this.scopes.includes(s)) {
                    _this.scopes.push(s);
                }
            });
        }
    }
    AuthClient.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // todo make a call to revoke the token
                LocalStorage_1.default.setItem("auth.is.authenticated", { value: false });
                LocalStorage_1.default.removeItem("auth.token");
                return [2 /*return*/, true];
            });
        });
    };
    AuthClient.prototype.getTokenSilently = function () {
        var _a, _b;
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        return (_b = (_a = LocalStorage_1.default.getItem("auth.token")) === null || _a === void 0 ? void 0 : _a.raw) !== null && _b !== void 0 ? _b : "";
    };
    /**
     *
     * @param {CredentialsLoginParams} options
     * @returns {Promise<IdentityTokenContract>}
     */
    AuthClient.prototype.loginWithCredentials = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var data, authResponse, decoder, decodedToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = __assign(__assign({}, options), { grantType: "implicit", applicationId: this.application });
                        if (this.scopes.length > 0) {
                            data["scopes"] = this.scopes.join(",");
                        }
                        return [4 /*yield*/, this.httpRequest.post("api/v1/oauth/token", data)];
                    case 1:
                        authResponse = _a.sent();
                        decoder = new TokenDecoder_1.TokenDecoder(authResponse.token.token);
                        decodedToken = decoder.getDecodedToken("*.uninow.com");
                        //this.cache.save({
                        //	audience: 'default',
                        //	scope: this.DEFAULT_SCOPE,
                        //	idToken: decodedToken.getId() || '',
                        //	accessToken: 'sd',
                        //	expiresIn: 10000,
                        //	decodedToken: decodedToken
                        //});
                        LocalStorage_1.default.setItem("auth.is.authenticated", { value: true });
                        LocalStorage_1.default.setItem("auth.token", {
                            raw: authResponse.token.token,
                            expiresAt: decodedToken.expiredAt()
                        });
                        //ClientStorage.save('auth.is.authenticated', true, { daysUntilExpire: 1 });
                        return [2 /*return*/, decodedToken];
                }
            });
        });
    };
    AuthClient.prototype._url = function (path) {
        var telemetry = encodeURIComponent(btoa(JSON.stringify({
            name: "auth-spa-js",
            version: version_1.default
        })));
        return "" + this.domainUrl + path + "&authClient=" + telemetry;
    };
    /**
     *
     * @param {GetUserOptions} options
     * @returns {Promise<any>}
     */
    AuthClient.prototype.getUser = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var token;
            return __generator(this, function (_c) {
                token = (_b = (_a = LocalStorage_1.default.getItem("auth.token")) === null || _a === void 0 ? void 0 : _a.raw) !== null && _b !== void 0 ? _b : "";
                this.addJWTAuthorization(token);
                return [2 /*return*/, this.httpRequest.get("api/v1/profile").then(function (response) {
                        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                        // @ts-ignore
                        return response.data;
                    }).catch(function (e) {
                        if (e.statusCode === 401) {
                            LocalStorage_1.default.setItem("auth.is.authenticated", { value: false });
                            LocalStorage_1.default.removeItem("auth.token");
                            throw new Errors_1.AuthenticationError("Not Authorized", "The authentication failed", "error");
                        }
                    })];
            });
        });
    };
    AuthClient.prototype.isAuthenticated = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUser()];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, !!user];
                }
            });
        });
    };
    return AuthClient;
}());
exports.default = AuthClient;
